export function getCurrencyByCountry(country: string): string {
  let currency = '';

  switch (country) {
    case 'AT':
    case 'BE':
    case 'CY':
    case 'EE':
    case 'FI':
    case 'FR':
    case 'DE':
    case 'GR':
    case 'IE':
    case 'IT':
    case 'LV':
    case 'LT':
    case 'LU':
    case 'MT':
    case 'NL':
    case 'PT':
    case 'SK':
    case 'SI':
    case 'ES':
    case 'CH':
      currency = 'EUR';
      break;
    case 'BG':
      currency = 'BGN';
      break;
    case 'CZ':
      currency = 'CZK';
      break;
    case 'HU':
      currency = 'HUF';
      break;
    case 'NO':
      currency = 'NOK';
      break;
    case 'PL':
      currency = 'PLN';
      break;
    case 'RO':
      currency = 'RON';
      break;
    case 'SE':
      currency = 'SEK';
      break;
    case 'GB':
      currency = 'GBP';
      break;
    case 'US':
      currency = 'USD';
      break;
  }

  return currency;
}
